
import { apiCalls,authApiCalls } from "./apiCalls";

let config = {
  base_url_2:"https://pulsedb-qa.pulselabs.co.in"
}
export const getToken = () => {
  const url = config.base_url_2 + `/rest/api/v1/partner_login`;
  const reqObject = {
    partner: "Pulse-Demo",
    key: "Pulse$007",
  };
  return apiCalls("post", url, reqObject);
};

export const getMFFundRanking = (period, from, fund_category) => {
  const url = config.base_url_2 + `/rest/api/v1/fund_ranking`;
  const reqObject = {
    size: 5,
    from: from,
    auth: "{{auth_token}}",
    asset_sub_category: fund_category,
    scheme_code: "",
    plan_name: "Broker",
    option_name: "Growth",
    amc_codes: "",
    weightages: [
      {
        period: period,
        parameter: "CAGR",
        parameter_type: "returns",
        weightage: 100,
      },
    ],
  };
  return apiCalls("post", url, reqObject);
};

export const getMFTrailingReturn = (scheme, years) => {
  const url = config.base_url_2 + `/rest/api/v1/mf/comparision/trailing`;
  const reqObject = {
    auth: "{{auth_token}}",
    scheme_codes: scheme,
    from: years,
    ranges: "1Y,3Y,5Y,7Y",
  };
  return apiCalls("post", url, reqObject);
};

export const getRemainingFundsAnalysis = (
  schemeCode,
  investmentValue,
  investment_value_recurring,
  toYears,
  fromYears,
  benchmarkCode
) => {
  const url = config.base_url_2 + "/rest/api/v1/portfolio/bm-timeseries-mom";
  const reqObject = {
    investment_value: investmentValue,
    investment_value_recurring: investment_value_recurring,
    from: fromYears,
    to: toYears,
    FD_ROI: 7.5,
    SB_ROI: 4,
    benchmark_allocation: [
      {
        benchmark_code: benchmarkCode,
        allocation: "100",
      },
    ],
  };
  return authApiCalls("post", url, reqObject);
};

export const getCrntFundsAnalysis = (
  schemeCode,
  investmentValue,
  investment_value_recurring,
  toYears,
  fromYears
) => {
  const url = config.base_url_2 + "/rest/api/v1/portfolio/mf-timeseries-mom";
  const reqObject = {
    investment_value: investmentValue,
    investment_value_recurring: investment_value_recurring,
    from: fromYears,
    to: toYears,
    scheme_allocation: [
      {
        scheme_code: schemeCode,
        allocation: "100",
      },
    ],
  };
  return authApiCalls("post", url, reqObject);
};
export const getFundsMetaData = (schemeCode, date) => {
  const url = config.base_url_2 + "/rest/api/v1/fundcard";
  const reqObject = {
    scheme_code: schemeCode,
    plan_name: "",
    as_on: date,
  };
  return authApiCalls("post", url, reqObject);
};
export const getSectorsHoldingMF = (schemeCode) => {
  const url = config.base_url_2 + "/rest/api/v1/mf/scheme_holdings_sector";
  const reqObject = {
    scheme_code: schemeCode,
    as_on: "",
    portfolio_type: "top-10",
  };
  return authApiCalls("post", url, reqObject);
};

export const getSecurityHoldingMF = (schemeCode) => {
  const url = config.base_url_2 + "/rest/api/v1/mf/scheme_holdings_security";
  const reqObject = {
    scheme_code: schemeCode,
    as_on: "",
    portfolio_type: "top-10",
  };
  return authApiCalls("post", url, reqObject);
};

export const getKeyQuants = (schemeCode) => {
  const url = config.base_url_2 + "/rest/api/v1/mf/analytical-data";
  const reqObject = {
    scheme_code: schemeCode,
  };
  return authApiCalls("post", url, reqObject);
};
